import PropTypes from 'prop-types';

const ModalMessage = {
  isWarning: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};

export default ModalMessage;
